var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      class: _vm.message.displayClass,
      attrs: {
        title: _vm.messageTimeLocalize,
      },
    },
    [
      _c(
        "span",
        {
          staticClass: "actor",
        },
        [_vm._v(_vm._s(_vm.message.actor))]
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "mb-0 rounded text-white p-3 d-inline-block message text-left text-wrap w-100",
        },
        [
          _c("div", {
            staticClass: "caret",
          }),
          _vm._v("\n    " + _vm._s(_vm.message.message) + "\n  "),
        ]
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "time text-muted",
        },
        [_vm._v(_vm._s(_vm.messageTimeHumanize))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }